var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticStyle: {
          position: "absolute",
          top: "0",
          left: "0",
          "z-index": "1",
          width: "100%",
          height: "100%",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          transform: "scale(0.6)",
          overflow: "hidden",
        },
      },
      [
        _c("div", { staticClass: "lds-roller-page" }, [
          _c("div"),
          _c("div"),
          _c("div"),
          _c("div"),
          _c("div"),
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }